export const fallbackLng = "en";
export const languages = [
  fallbackLng,
  "ar",
  "br",
  "cf",
  "cn",
  "de",
  "es",
  "fr",
  "ja",
  "ko",
  "pt",
  "ru",
  "tr",
  "vn",
  "zh",
] as const;
export const defaultNS = "translation";
export const cookieName = "i18next";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
